import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import { styled } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { useLoadingDispatch, showLoading, hideLoading } from "../../context/loadingContext";
import { Button, Row, Col, Tag, Flex, Divider, Card, Input } from "antd";
import { useSelector } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import InfoCards from "../../Components/InfoCards";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  BarcodeOutlined,
  ShoppingOutlined,
  EnvironmentOutlined,
  SwapRightOutlined,
  NumberOutlined,
  QrcodeOutlined,
  TagOutlined,
  CalendarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import DetailsGrid from "../../Components/common/DetailsGrid";
import { type } from "@testing-library/user-event/dist/type";
import { decodeId } from "../../Components/common/CommonFun";
const Auth = new AuthService();

const DataSheet = styled("div")`
  .label {
    font-weight: 600;
    color: #666;
    min-width: 130px;
  }
  .value {
    font-weight: 500;
  }
  .ant-card {
    border-radius: 12px;
    margin-bottom: 16px;
  }
`;

export default function TransferStockDetails() {
  const navigate = useNavigate();
  const { products, locations } = useSelector(
    (state) => state?.AppState?.userCreds
  );
  const params = useParams();
  const layoutDispatch = useLoadingDispatch();
    const decodedID = decodeId(params?.id)

  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [details, setDetails] = React.useState(null);

  const getDataByID = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/transfer-stock?id=${id}`);
      if (res.ack) {
        setDetails(res?.transfer_stock[0] || {});
      }
    } catch (error) {
      showMessage("error", "Something went wrong");
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  React.useEffect(() => {
    if (id > 0) {
      getDataByID();
    }
  }, []);

  const onClickCancel = () => {
    navigate("/transaction-transfer");
  };

const infoItems = [
    {
      label: "Code",
      value: details?.transfer_stock_code || "-",
      icon: <BarcodeOutlined style={{ color: "#1677ff" }} />,
      type: 'input',
    },
    {
      label: "Product",
      value: (() => {
        const product = products?.find(
          (p) => p.netsuite_id === details?.product_netsuite_id
        );
        return product ? `${product.code} - ${product.name}` : "-";
      })(),
      icon: <ShoppingOutlined style={{ color: "#52c41a" }} />,
      type: 'input',

    },
    {
      label: "Source Location",
      value:
        locations?.find((l) => l.id === details?.source_location_id)?.title ||
        "-",
      icon: <EnvironmentOutlined style={{ color: "#fa8c16" }} />,
        type: 'input',
    },
    {
      label: "Destination Location",
      value:
        locations?.find((l) => l.id === details?.dest_location_id)?.title ||
        "-",
      icon: <SwapRightOutlined style={{ color: "#722ed1" }} />,
      type: 'input',

    },
    {
      label: "Quantity",
      value: details?.quantity || "-",
      icon: <NumberOutlined style={{ color: "#13c2c2" }} />,
      type: 'input',

    },
    {
      label: "Batch Code",
      value: details?.batch_code || "-",
      icon: <QrcodeOutlined style={{ color: "#eb2f96" }} />,
      type: 'input',

    },
    {
      label: "Supplier Batch Code",
      value: details?.supplier_batch_code || "-",
      icon: <TagOutlined style={{ color: "#fa541c" }} />,
      type: 'input',

    },
    {
      label: "Expiry Date",
      value: details?.expiry_date
        ? dayjs(details.expiry_date).format("DD-MMM-YYYY")
        : "-",
      icon: <CalendarOutlined style={{ color: "#2f54eb" }} />,
      type: 'input',

    },
    {
      label: "User",
      value: details?.helper_name || details?.user_name || "-",
      icon: <UserOutlined style={{ color: "#a0d911" }} />,
      type: 'input',

    },
  ];


  return (
    <DataSheet>
      <Flex align="center" justify="space-between" style={{ marginBottom: 12 }}>
        <h3 style={{ margin: 0 }}>Transfer Stock Details</h3>
        <Button onClick={onClickCancel} icon={<ArrowLeftOutlined/>}>Back</Button>
      </Flex>

      <Divider />

      {details ? (
    <DetailsGrid infoItems={infoItems}  />
    // <Row gutter={[6, 1]}>
    //     {infoItems.map((item, index) => (
    //       <Col xs={24} sm={24} md={12} key={index}>
    //         <Card
    //           size="small"
    //           style={{
    //             borderRadius: 12,
    //             boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    //           }}
    //         >
    //           <div
    //             style={{
    //               display: "flex",
    //               alignItems: "center",
    //               marginBottom: 6,
    //               fontWeight: 600,
    //               color: "#595959",
    //             }}
    //           >
    //             {iconMap[item.label]}{" "}
    //             <span style={{ marginLeft: 8 }}>{item.label}</span>
    //           </div>
    //           <Input
    //             value={item.value}
    //             readOnly
    //             style={{
    //               background: "#fafafa",
    //               borderRadius: 8,
    //               cursor: "default",
    //               fontWeight: 500,
    //               color: "#262626",
    //             }}
    //           />
    //         </Card>
    //       </Col>
    //     ))}
    //   </Row>
      ) : (
        <p style={{ marginTop: 20 }}></p>
      )}
    </DataSheet>
  );
}
